<ng-container *ngIf="isShow">
  <div class="overlay">
    <form class="modal-content" [formGroup]="registrationForm" (submit)="addUserData()">
      <h4>{{ modalName }}</h4>
      <button (click)="closeModal()" type="button" class="modal-content__close"></button>
      <div class="modal-content__alert" *ngIf="isControlInvalid('name') && !isLoginTemplate">
        Type a name(more than 8 and below than 30 charts)
      </div>
      <input
        type="text"
        placeholder="Enter Name"
        formControlName="name"
        id="name"
        maxlength="30"
        *ngIf="!isLoginTemplate"
      />
      <div class="modal-content__alert" *ngIf="isControlInvalid('email')">Type an email</div>
      <input type="text" placeholder="Enter Email" formControlName="email" id="email" />
      <div class="modal-content__alert" *ngIf="isControlInvalid('password')">
        Type a password(more than 8 and below than 25 charts)
      </div>
      <input
        type="password"
        placeholder="Enter Password"
        formControlName="password"
        id="password"
        maxlength="25"
      />
      <img
        [src]="imgURL"
        alt="avatar"
        class="modal-content__avatar"
        *ngIf="!isLoginTemplate"
        #avatar
      />
      <input
        #file
        type="file"
        accept="image/*"
        (change)="preview(file.files)"
        id="avatar-choose"
        *ngIf="!isLoginTemplate"
      />
      <label for="avatar-choose" class="modal-content__label-file" *ngIf="!isLoginTemplate">
        <img src="../../../../assets/img/download-icon.png" alt="load-icon" />
        <span class="label-file__label-file-name">Загрузить файл</span>
      </label>
      <p>By creating an account you agree to our <span>Terms & Privacy</span>.</p>
      <button type="submit" class="modal-content__registerbtn">{{ modalName }}</button>
      <div
        class="modal-content__container modal-content__signin"
        *ngIf="!isLoginTemplate; else signInBtn"
      >
        <p>
          Already have an account?
          <button (click)="changeModal()">Login</button>.
        </p>
      </div>
    </form>
  </div>
</ng-container>

<ng-template #signInBtn>
  <div class="modal-content__container modal-content__signin">
    <p>
      Have not an account?
      <button (click)="changeModal()">Register</button>.
    </p>
  </div>
</ng-template>
